"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var columns_change_event_type_1 = require("./columns-change-event-type");
var ColumnsChangeEvent = /** @class */ (function () {
    function ColumnsChangeEvent(columnsDepth, branchIndexesDif, type) {
        if (branchIndexesDif === void 0) { branchIndexesDif = new Map(); }
        if (type === void 0) { type = columns_change_event_type_1.ColumnsChangeEventType.COLUMNS_DEPTH_CHANGED; }
        this.columnsDepth = columnsDepth;
        this.type = type;
        this.branchIndexesDif = branchIndexesDif;
    }
    return ColumnsChangeEvent;
}());
exports.ColumnsChangeEvent = ColumnsChangeEvent;
//# sourceMappingURL=columns-change-event.js.map